import { useSelector } from 'react-redux';
import { FEATURES } from '../../account/api/getFeaturesForUserId';

const SETTINGS_TABS = [
    { name: 'Account', path: '/account' },
    { name: 'Payment Info', path: '/payment' },
];

const MARKETPLACE_SUBSCRIPTIONS_TAB = { name: 'Marketplace Subscriptions', path: '/marketplace-subscriptions' };

const ATHLETE_TABS = [
    { name: 'Data Export', path: '/data-export' }
];

const HEAD_COACH_SETTINGS_TABS = [
    { name: 'Coach Plans', path: '/subscription-plans' },
    { name: 'Manage Assistant Coaches', path: '/assistant-coaches' },
    { name: 'Payment History', path: '/billing' }
];

const MARKETPLACE_COACH_TABS = [{ name: 'Zapier Integrations', path: '/integrations' }];

export default function useTabNavigation() {
    const headCoach = useSelector((state: any) => state.user.headCoach);
    const features = useSelector((state: any) => state.features);
    const showMarketplaceSubscriptions = features?.[FEATURES.WEB_TEAM_SUBSCRIPTION_MANAGEMENT_V1];

    const settingsTabs = showMarketplaceSubscriptions
        ? SETTINGS_TABS.concat(MARKETPLACE_SUBSCRIPTIONS_TAB)
        : SETTINGS_TABS;

    const headCoachTabs = headCoach?.isMarketplaceEnabled
        ? HEAD_COACH_SETTINGS_TABS.concat(settingsTabs).concat(MARKETPLACE_COACH_TABS)
        : HEAD_COACH_SETTINGS_TABS.concat(settingsTabs);

    if (headCoach) {
        return headCoachTabs;
    }

    return settingsTabs.concat(ATHLETE_TABS);
}
